const overdueApplicationInboxes = [
    {
        "uuid": "1",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122901",
        "appType": "initial",
        "activity": "overdue_S10",
        "customerNo": "0001",
        "customerName": "等待繳費客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "payment",
        "appActivity": "payment_S10",
        "overdueReason": "R01",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "2",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122902",
        "appType": "initial",
        "activity": "overdue_S10",
        "customerNo": "0002",
        "customerName": "文件審查客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "documentReview",
        "appActivity": "documentReview_S30",
        "overdueReason": "R02",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "3",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122903",
        "appType": "initial",
        "activity": "overdue_S10",
        "customerNo": "0003",
        "customerName": "實地查驗客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "inspection",
        "appActivity": "inspection_S10",
        "overdueReason": "R03",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "4",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122904",
        "appType": "initial",
        "activity": "overdue_S10",
        "customerNo": "0004",
        "customerName": "書面複評客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "writtenReview",
        "appActivity": "writtenReview_S10",
        "overdueReason": "R04",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "5",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122905",
        "appType": "renewal",
        "activity": "overdue_S10",
        "customerNo": "0005",
        "customerName": "等待繳費客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "payment",
        "appActivity": "payment_S10",
        "overdueReason": "R05",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "6",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122906",
        "appType": "renewal",
        "activity": "overdue_S10",
        "customerNo": "0006",
        "customerName": "實地查驗客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "inspection",
        "appActivity": "inspection_S10",
        "overdueReason": "R06",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "9",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122909",
        "appType": "initial",
        "activity": "overdue_S10",
        "customerNo": "0009",
        "customerName": "文審逾期客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "documentReview",
        "appActivity": "documentReview_S30",
        "overdueReason": "R09",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
    },
    {
        "uuid": "11",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122911",
        "appType": "renewal",
        "activity": "overdue_S20",
        "customerNo": "0011",
        "customerName": "等待繳費客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "payment",
        "appActivity": "payment_S10",
        "overdueReason": "R05",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
        "customerOverdueReason": "客戶逾期原因.................\n................................\n..................................",
        "customerNotifiedDate": "2021-01-03T00:00:00.000Z",
        "suggestionOfDecision": "wait",
        "suggestedReviewDescription": "建議審查說明.................\n................................\n..................................",
        "timeComplianceRate": "onTime",
    },
    {
        "uuid": "12",
        "notifiedDate": "2021-12-29T00:00:00.000Z",
        "appNo": "A21122912",
        "appType": "renewal",
        "activity": "overdue_S20",
        "customerNo": "0012",
        "customerName": "實地查驗客戶",
        "assessmentPlace": "台東廠",
        "appPhase": "inspection",
        "appActivity": "inspection_S10",
        "overdueReason": "R06",
        "systemNotifyingDate": "2022-01-25T15:39:00.000Z",
        "assessmentProducts":[
            {
                "name": "杏仁玄米餅",
                "tseyueLevel": "doubleClean",
                "leezenLevel": "good",
                "processStatus": "frontEnd",
                "backEndProductName": "杏仁玄米餅",
            },
            {
                "name": "Pasta義大利麵",
                "tseyueLevel": "clean",
                "leezenLevel": "excellent",
                "processStatus": "backEnd",
                "backEndProductName": "",
            }
        ],
        "customerOverdueReason": "客戶逾期原因.................\n................................\n..................................",
        "customerNotifiedDate": "2021-01-03T00:00:00.000Z",
        "suggestionOfDecision": "suspend",
        "suggestedReviewDescription": "建議審查說明.................\n................................\n..................................",
        "timeComplianceRate": "delay",
        "assessmentProductsSelection": [0, 1],
        "inspectionDescription": "本次查驗說明.................\n................................\n..................................",
        "ncr": '依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第OOOO 條，有下列情形:\n' +
            '(一)\t次要不符合或經評鑑決定須限期改善之事項，未於限期內改善，或經限期改善三次仍未通過審查。\n' +
            '(二)\t因延遲矯正或經限期改善未完成，致查驗後三個月內無法通過審查。\n' +
            '(三)\t於xxxx/xx/xx通知繳交評鑑費用，經催繳超過十五天仍未繳交。\n' +
            '(四)\t因可歸責客戶之事由，致展延查驗之書面審查六個月內未完成補件、改善或不符合規定。\n' +
            '(五)\t因OOOO因素無法接受每年定期追蹤查驗或每三年展延查驗，貴司於xxxx/xx/xx提出申請經本公司審查同意。\n' +
            '(六)\t未遵守申請書之確認聲明或契約書之所述內容。\n' +
            '(七)\t產品『產品名稱OOO』(有效日期xxxx/xx/xx)或產品『產品名稱OOO』所用之原料『OOOO』(有效日期xxxx/xx/xx)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準。\n' +
            '(八)\t使用評鑑證書、本公司服務標誌或評鑑標章不符合本公司規定或有誤導消費者之嫌，經通知限期改善仍未完成改善者。\n' +
            '(九)\t販賣、展示或廣告『產品名稱OOO』，未通過評鑑而聲稱為已評鑑產品。',
        "noticeAndCorrection": '(一)\t貴公司於xxxx/xx/xx(通知日系統帶入)後不可再生產印有評鑑標章之『產品名稱OOO』產品和宣傳。\n' +
            '(二)\tOOOO原料(有效日期xxxx/xx/xx)禁止再使用；使用此批原料之產品禁止出貨，已售出產品應於一日內下架，十日內完成回收。\n' +
            '(三)\t產品『○○○○』(有效日期xxxx/xx/xx)禁止以本公司評鑑名義繼續販售，已售出產品應於一日內下架，十日內完成回收。\n' +
            '(四)\t請於15天內(西元年/月/日前)回覆本公司下列資料：\n' +
            '1.\t此批原料流向、不合格原因說明、原料後續處理方式、矯正說明及預防再發措施。\n' +
            '2.\t產品回收紀錄(請詳列產品生產日期、批號、包裝規格、生產數量/重量、銷售對象、回收數量…等)。\n' +
            '3.\t產品違規原因、矯正說明及預防再發措施。\n' +
            '(五)\t本公司收到相關資料後，得派員不定期查驗與檢驗產品/原料，相關費用將由  貴公司支付。\n' +
            '(六)\t為延續　 貴公司評鑑資格，倘限期內未提出矯正資料且無任何延宕說明者，本公司將依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第4.1.1.5條「經暫時終止其全部或部分評鑑範圍期滿後，未申請或未能有效矯正改善而導致無法恢復評鑑者」條文規定，終止『○○○○』評鑑資格。',
    },
]

export default overdueApplicationInboxes